import { useParams } from 'react-router';
import { useSession } from '@/stores/session';
import { Denied } from './ListKit';
import { PurchaseOrderDetail } from './PurchaseOrderDetail';

export function PurchaseOrderDetailPage() {
  const { id } = useParams();
  const can = useSession((st) => st.can);
  if (!can('purchase.read')) return <Denied what="查看采购单" perm="查看采购订单" />;
  return <PurchaseOrderDetail id={id!} />;
}
